var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcaseThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 17.8501V12H39.3101V17.8501",
    stroke: "#0B0B0B",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50.1699V19.8496C57 18.745 56.1046 17.8496 55 17.8496L9 17.8496C7.89543 17.8496 7 18.745 7 19.8496V50.1699C7 51.2745 7.89543 52.1699 9 52.1699H55C56.1046 52.1699 57 51.2745 57 50.1699Z",
    fill: "#00C5A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31.6191H57",
    stroke: "#0B0B0B",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3101 28.6992H25.6997C25.1474 28.6992 24.6997 29.1469 24.6997 29.6992V33.5391C24.6997 34.0913 25.1474 34.5391 25.6997 34.5391H38.3101C38.8623 34.5391 39.3101 34.0913 39.3101 33.5391V29.6992C39.3101 29.1469 38.8623 28.6992 38.3101 28.6992Z",
    fill: "#BDEA09"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseThree);
export default __webpack_public_path__ + "static/media/suitcase-three.5a91e15296de12cdb64917f548e11289.svg";
export { ForwardRef as ReactComponent };